<template>
<div id="app" @click="info">
  <header_nav v-if="!is_header"></header_nav>
<!--  <transition name="fade">-->
<!--  <keep-alive>-->
    <router-view v-wechat-title="$route.meta.title"/>
<!--  </keep-alive>-->

<!--  </transition>-->
  <foot v-if="!is_foot"></foot>
</div>
</template>

<script>

import wx from "weixin-js-sdk";

export default {
  name: 'App',
  data(){
    return{
      is_foot:'',
      wxTitle: '',
      wxLink: location.href,
      imgUrl: 'http://testwap.majixing.com/static/img/wechat_share_majixing.png',
      desc: location.href,//描述
      is_header:''
    }
  },
  methods:{
    info(){
      this.$EventBus.$emit('msg',false)
    },
    //微信分享
    wxShare(){
      let t= this;
      let url = location.href.split('#')[0];
      let uri = encodeURIComponent(url);
      this.$http.post('api/wechat_official_account/getAuthorization',{url:uri,type:1}).then(res=>{
        let appId = res.data.data.appid;
        let timestamp = res.data.data.timestamp;
        let nonceStr = res.data.data.nonceStr;
        let signature = res.data.data.signature;
        wx.config({
          debug: false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: sessionStorage.appId,         // 必填，公众号的唯一标识，填自己的！
          timestamp: Number(sessionStorage.timestamp), // 必填，生成签名的时间戳，刚才接口拿到的数据
          nonceStr: sessionStorage.nonceStr,   // 必填，生成签名的随机串
          signature: sessionStorage.signature, // 必填，签名，见附录1
          jsApiList: [
            'hideMenuItems',
            'onMenuShareAppMessage',
            'onMenuShareTimeline'
          ]
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: ["menuItem:copyUrl","menuItem:editTag","menuItem:delete","menuItem:originPage","menuItem:readMode", "menuItem:openWithQQBrowser", "menuItem:openWithSafari","menuItem:share:email","menuItem:share:brand","menuItem:share:qq","menuItem:share:QZone"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
          });
          //分享到朋友圈
          wx.onMenuShareTimeline({
            title: t.wxTitle,   // 分享时的标题
            link: location.href,     // 分享时的链接
            imgUrl: t.imgUrl,    // 分享时的图标
            success: function () {
              console.log("分享成功");
            },
            cancel: function () {
              console.log("取消分享");
            }
          });
          //分享给朋友
          wx.onMenuShareAppMessage({
            title:  t.wxTitle,
            desc: t.desc,
            link: location.href,
            imgUrl: t.imgUrl,
            type: '',
            dataUrl: '',
            success: function () {
              console.log("分享成功");
            },
            cancel: function () {
              console.log("取消分享");
            }
          });
        });
        // wx.error(function(res){
        //   // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        //   // alert("errorMSG:"+res);
        // });
      })
    },
  },
  watch:{
    '$route':function () {
      this.is_foot = this.$route.meta.is_foot;
      this.is_header = this.$route.meta.is_header;
      this.wxTitle = this.$route.meta.title;
      if(!this.$route.meta.needShare){
        this.wxShare();
      }
    }
  }
}
</script>

<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue